import { render, staticRenderFns } from "./restaurant-list.vue?vue&type=template&id=25f97a2b&scoped=true"
import script from "./restaurant-list.vue?vue&type=script&lang=js"
export * from "./restaurant-list.vue?vue&type=script&lang=js"
import style0 from "./restaurant-list.vue?vue&type=style&index=0&id=25f97a2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f97a2b",
  null
  
)

export default component.exports